import { computed } from 'vue'
import { isActive } from '@/services/feature-flag-service'

export const isContentCollectionsPackageActive = computed(() =>
  isActive('fox_web_collections_package')
)
